import * as React from 'react'
import { InfoTooltip } from '../InfoTooltip'
import { styled } from '../styled-components'

interface IProps {
  label?: string
  tooltip?: string
  infoLink?: string
  checked: boolean
  className?: string
  onChange?: (value: boolean) => void
}

export const RadioButtonControl = (props: IProps) => {
  const { label, checked, className, onChange, tooltip, infoLink } = props
  return (<Container className={className} onClick={() => onChange && onChange(!checked)}>
    <Box checked={checked} />
    {label && <Label>{label}</Label>}
    {(tooltip || infoLink) && <InfoTooltip small link={props.infoLink}>{tooltip}</InfoTooltip>}
  </Container>)
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

const Label = styled.div`
  font-size: 14px;
`

const Box = styled.div<{ checked?: boolean }>`
  flex: 0 0 auto;
  margin-right: 15px;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  background: ${props => props.checked ? props.theme.primaryColor : props.theme.checkboxBackgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease-out;
  &:after {
    display: block;
    content: '';
    width: ${props => props.checked ? '12px' : '0'};
    height: ${props => props.checked ? '12px' : '0'};
    border-radius: 50%;
    background: white;
    transition: all 0.1s ease-out;
  }
`
